import _classCallCheck from "/var/lib/jenkins/workspace/vix.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/lib/jenkins/workspace/vix.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/lib/jenkins/workspace/vix.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/lib/jenkins/workspace/vix.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/lib/jenkins/workspace/vix.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * DevExtreme (esm/core/templates/bindable_template.js)
 * Version: 22.1.5
 * Build date: Fri Sep 02 2022
 *
 * Copyright (c) 2012 - 2022 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import $ from "../renderer";
import { TemplateBase } from "./template_base";
import eventsEngine from "../../events/core/events_engine";
import { removeEvent } from "../../events/remove";
import { isPrimitive } from "../utils/type";

var watchChanges = function watchChanges(rawData, watchMethod, fields, fieldsMap, callback) {
  var fieldsDispose;

  var globalDispose = function (data, watchMethod, callback) {
    return watchMethod(function () {
      return data;
    }, callback);
  }(rawData, watchMethod, function (dataWithRawFields) {
    fieldsDispose && fieldsDispose();

    if (isPrimitive(dataWithRawFields)) {
      callback(dataWithRawFields);
      return;
    }

    fieldsDispose = function (data, watchMethod, fields, fieldsMap, callback) {
      var resolvedData = {};
      var missedFields = fields.slice();
      var watchHandlers = fields.map(function (name) {
        var fieldGetter = fieldsMap[name];
        return watchMethod(fieldGetter ? function () {
          return fieldGetter(data);
        } : function () {
          return data[name];
        }, function (value) {
          resolvedData[name] = value;

          if (missedFields.length) {
            var index = missedFields.indexOf(name);

            if (index >= 0) {
              missedFields.splice(index, 1);
            }
          }

          if (!missedFields.length) {
            callback(resolvedData);
          }
        });
      });
      return function () {
        watchHandlers.forEach(function (dispose) {
          return dispose();
        });
      };
    }(dataWithRawFields, watchMethod, fields, fieldsMap, callback);
  });

  return function () {
    fieldsDispose && fieldsDispose();
    globalDispose && globalDispose();
  };
};

export var BindableTemplate =
/*#__PURE__*/
function (_TemplateBase) {
  _inherits(BindableTemplate, _TemplateBase);

  function BindableTemplate(render, fields, watchMethod, fieldsMap) {
    var _this;

    _classCallCheck(this, BindableTemplate);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(BindableTemplate).call(this));
    _this._render = render;
    _this._fields = fields;
    _this._fieldsMap = fieldsMap || {};
    _this._watchMethod = watchMethod;
    return _this;
  }

  _createClass(BindableTemplate, [{
    key: "_renderCore",
    value: function _renderCore(options) {
      var _this2 = this;

      var $container = $(options.container);
      var dispose = watchChanges(options.model, this._watchMethod, this._fields, this._fieldsMap, function (data) {
        $container.empty();

        _this2._render($container, data, options.model);
      });
      eventsEngine.on($container, removeEvent, dispose);
      return $container.contents();
    }
  }]);

  return BindableTemplate;
}(TemplateBase);